import React, { FC, useState } from "react";
import { AppBar, Toolbar } from "@material-ui/core";

import NavBarRightSection from "./NavBarRightSection";
import NavBarLeftSection from "./NavBarLeftSection";
import "./Navigator.css";

const NavigatorPrototye = ({ data, loading, rightMenuData }): FC => {
  const [openItem, setOpenItem] = useState(null);
  const payload = { openItem, setOpenItem };
  return (
    <div className="root">
      <AppBar
        className="appbar"
        position="fixed"
        classes={{
          colorPrimary: {
            backgroundColor: "#d5e14d",
          },
        }}
      >
        <Toolbar>
          {!loading && (
            <>
              <NavBarLeftSection data={data} {...payload} />
              <NavBarRightSection data={rightMenuData} {...payload} />
            </>
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
};
export default NavigatorPrototye;
